import { CoinCondition, CoinGrade, CoinPurchaseCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  co_country_of_origin: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },

  co_category: {
    friendly: 'Category',
    validations: {
      maxLength: 150,
    },
  },

  co_period: {
    friendly: 'Period',
    validations: {
      maxLength: 100,
    },
  },

  co_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: CoinCondition,
    },
  },

  co_grade: {
    friendly: 'Grade',
    validations: {
      type: 'enum',
      enumType: CoinGrade,
    },
  },

  co_ngc_no: {
    friendly: 'NGC #',
    validations: {
      maxLength: 100,
    },
  },

  co_pcgs_no: {
    friendly: 'PCGS #',
    validations: {
      maxLength: 100,
    },
  },

  co_krause_no: {
    friendly: 'Krause #',
    validations: {
      maxLength: 100,
    },
  },

  co_year: {
    friendly: 'Year',
    validations: {
      maxLength: 100,
    },
  },

  co_denomination: {
    friendly: 'Denomination',
    validations: {
      maxLength: 100,
    },
  },

  co_mintmark: {
    friendly: 'Mintmark',
    validations: {
      maxLength: 100,
    },
  },

  co_mint: {
    friendly: 'Mint',
    validations: {
      maxLength: 100,
    },
  },

  co_mintage: {
    friendly: 'Mintage',
    validations: {
      maxLength: 100,
    },
  },

  co_variety: {
    friendly: 'Variety',
    validations: {
      maxLength: 150,
    },
  },

  co_composition: {
    friendly: 'Composition',
    validations: {
      maxLength: 100,
    },
  },

  co_diameter: {
    friendly: 'Diameter',
    validations: {
      maxLength: 100,
    },
  },

  co_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 100,
    },
  },

  co_edge: {
    friendly: 'Edge',
    validations: {
      maxLength: 100,
    },
  },

  co_designer: {
    friendly: 'Designer',
    validations: {
      maxLength: 150,
    },
  },

  co_obverse_inscription: {
    friendly: 'Obverse Inscription',
    validations: {
      maxLength: 250,
    },
    typeHint: typeHints.TextArea,
  },

  co_reverse_inscription: {
    friendly: 'Reverse Inscription',
    validations: {
      maxLength: 250,
    },
    typeHint: typeHints.TextArea,
  },

  co_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: CoinPurchaseCondition,
    },
  },

};

export default attributes;

export const CoinDefaultSplitAttribute = 'co_country_of_origin';

export const CoinRequiredAttributes = [];

export const CoinItemSearchAttributes = ['co_country_of_origin', 'co_denomination', 'co_year'];

export const CoinOverviewAttributes = ['title', 'co_country_of_origin', 'co_category', 'co_period', 'co_condition', 'co_grade', 'rarity', 'market_value',
  'co_ngc_no', 'co_pcgs_no', 'quantity', 'inventory_no', 'tags'];

export const CoinSpecificationAttributes = ['co_denomination', 'co_mintmark', 'co_mint', 'co_mintage', 'co_variety', 'co_composition', 'co_weight',
  'co_diameter', 'co_edge', 'co_designer', 'co_obverse_inscription', 'co_reverse_inscription'];

export const CoinPurchaseAttributes = ['purchase_date', 'purchase_price', 'co_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const CoinDetailAttributes = [];

export const CoinDisplayAttributes = ['co_country_of_origin', 'co_denomination', 'co_year', 'co_composition', 'tags'];

export const CoinSliderGalleryAttributes = {
  titleKey: 'co_country_of_origin',
  subtitleKey: 'co_denomination',
};



// WEBPACK FOOTER //
// ./src/config/coinDataAttributes.js